export default class OutsideGate extends PIXI.Container {

    constructor() {
        super();

        this._gateRight = new PIXI.Sprite(P3.assets.texture("gates_r"));
        this._gateRight.visible = false;
        this.addChild(this._gateRight);

        this._gateClosed = new PIXI.Sprite(P3.assets.texture("gates_closed"));
        this.addChild(this._gateClosed);

    }

    open() {
        this._gateClosed.visible = false;
        //this._gateLeft.visible = true;
        this._gateRight.visible = true;
    }

}